import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import WizardFooter from "./WizardFooter";
import HelpBubble from "./HelpBubble";

export const fields = ["first_name", "last_name", "email"];

export const WizardFormOptOut = props => {
  const {
    allText,
    handleSubmit,
    handleContinue,
    fields: { first_name, last_name },
  } = props;
  const text = Object.assign(
    {},
    allText.shared,
    allText.intro,
    allText.intro01
  );

  return (
    <span>
      <form onSubmit={handleSubmit} className="form-horizontal">
        <div className="wizard-page-content wizard-page-short">
          <div className="page-top-information">{text.information01}</div>
          <div className="row page-title-container">
            <div className="col-12 col-md-10 col-lg-8 page-title">
              {text.title2}
            </div>
          </div>
          <div className="wizard-text paragraph big intro-zero-one">
            {text.middleParagraph0101}
            <span className="employee-name">
              {first_name.value} {last_name.value}
            </span>
            {text.middleParagraph0102}
          </div>
          <div className="wizard-text paragraph big intro-zero-one">
            {text.middleParagraph0103}
          </div>
          <div className="wizard-text paragraph medium intro-zero-one">
            {text.middleParagraph03}
          </div>
          <div className="wizard-text paragraph medium intro-zero-one">
            {text.middleParagraph02}
            <button className="end-now-button" type="submit">
              {text.endNow}
            </button>
          </div>
        </div>
        <div className="row intro-bottom-paragraph">
          <div className="page-bottom-left-information" />

          <div className="col-12 col-sm-8 justify-content-center justify-content-sm-end right-information-container">
            <div className="clearfix text-left text-md-right page-bottom-right-information">
              <div className="page-bottom-right-information-text">
                {text.rightBottomInformation01}
              </div>
              <div className="page-bottom-right-information-text">
                {text.rightBottomInformation02}
              </div>
              <div className="page-bottom-right-information-text">
                {text.rightBottomInformation03}
              </div>
            </div>

            <div className="help-bubble-container">
              <HelpBubble />
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          nextLabel={text.continue}
          intro={true}
          nextPage={handleContinue}
        />
      </form>
    </span>
  );
};

WizardFormOptOut.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleContinue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
})(WizardFormOptOut);



// WEBPACK FOOTER //
// ./src/components/WizardFormOptOut.js